import { SvgIcon } from '@mui/material';

export function SuccessMessageIcon(props) {
	return (
		<SvgIcon
			width="64"
			height="112"
			viewBox="0 0 64 112"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M64 33.9279C64 39.1786 64 55.7193 64 60.97C64 61.6244 63.2262 61.9871 62.6942 61.585L44.2275 47.449L62.6942 33.3129C63.2262 32.9109 64 33.2735 64 33.9279Z"
				fill="url(#paint0_linear_2869_17994)"
			/>
			<path
				d="M28.0984 48.8122C30.3956 50.5704 33.6037 50.5704 35.909 48.8122C35.909 48.8122 58.5752 31.4753 62.3959 28.5582C62.7263 28.3059 62.7908 27.8566 62.5732 27.5097C60.8724 24.8054 57.8256 23 54.3354 23H9.66402C6.18188 23 3.12694 24.8054 1.42617 27.5097C1.20854 27.8566 1.27302 28.3059 1.60351 28.5582C5.42419 31.4753 28.0903 48.8122 28.0903 48.8122H28.0984Z"
				fill="url(#paint1_linear_2869_17994)"
			/>
			<path
				d="M-0.000488281 33.9279C-0.000488281 39.1786 -0.000488281 55.7193 -0.000488281 60.97C-0.000488281 61.6244 0.77332 61.9871 1.30531 61.585L19.7719 47.449L1.30531 33.3129C0.77332 32.9109 -0.000488281 33.2735 -0.000488281 33.9279Z"
				fill="url(#paint2_linear_2869_17994)"
			/>
			<path
				d="M40.9629 49.9473L38.3835 51.9183C36.5055 53.361 34.2485 54.0785 31.9916 54.0785C29.7346 54.0785 27.4857 53.361 25.6076 51.9183L23.0283 49.9473C23.0283 49.9473 4.91632 63.7995 1.54703 66.3618C1.2246 66.6062 1.15206 67.0477 1.36163 67.3946C3.05434 70.1461 6.12539 71.9988 9.64784 71.9988H54.3192C57.8416 71.9988 60.9207 70.154 62.6054 67.3946C62.815 67.0477 62.7505 66.6062 62.42 66.3618C59.0507 63.7916 40.9468 49.9473 40.9468 49.9473H40.9629Z"
				fill="url(#paint3_linear_2869_17994)"
			/>
			<path
				d="M31.9999 14.9998C30.9078 14.9998 30.0215 14.1009 30.0215 12.9934V2.00639C30.0215 0.898864 30.9078 0 31.9999 0C33.092 0 33.9783 0.898864 33.9783 2.00639V12.9934C33.9783 14.1009 33.092 14.9998 31.9999 14.9998Z"
				fill="url(#paint4_linear_2869_17994)"
			/>
			<path
				d="M43.5144 14.9999C43.0633 14.9999 42.6122 14.8474 42.2403 14.5344C41.4014 13.8202 41.2906 12.5602 41.995 11.7094L46.5057 6.26008C47.2101 5.40937 48.4525 5.29701 49.2913 6.01129C50.1302 6.72556 50.241 7.98558 49.5367 8.83629L45.0259 14.2856C44.6381 14.7592 44.0762 14.9999 43.5065 14.9999H43.5144Z"
				fill="url(#paint5_linear_2869_17994)"
			/>
			<path
				d="M20.4934 14.9999C19.9315 14.9999 19.3697 14.7592 18.974 14.2856L14.4632 8.83629C13.7589 7.98558 13.8697 6.72556 14.7085 6.01129C15.5474 5.29701 16.7898 5.40937 17.4941 6.26008L22.0049 11.7094C22.7092 12.5602 22.5984 13.8202 21.7596 14.5344C21.3877 14.8474 20.9366 14.9999 20.4855 14.9999H20.4934Z"
				fill="url(#paint6_linear_2869_17994)"
			/>
			<path
				d="M32 112C38.6274 112 44 106.627 44 100C44 93.3726 38.6274 88 32 88C25.3726 88 20 93.3726 20 100C20 106.627 25.3726 112 32 112Z"
				fill="url(#paint7_linear_2869_17994)"
			/>
			<path
				d="M26.25 100.512C26.25 100.512 28.4606 103.03 29.5286 104.175C30.1085 104.8 31.2626 104.857 31.7851 104.191C34.8054 100.314 37.7083 96.334 37.7083 96.334"
				stroke="#F7F7F7"
				strokeWidth="4"
				strokeLinecap="round"
				strokeLinejoin="round"
				style={{ color: 'transparent' }}
			/>
			<defs>
				<linearGradient
					id="paint0_linear_2869_17994"
					x1="64"
					y1="47.449"
					x2="0.160811"
					y2="47.3081"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#F372C2" />
					<stop offset="1" stopColor="#9747FF" />
				</linearGradient>
				<linearGradient
					id="paint1_linear_2869_17994"
					x1="0.160691"
					y1="36.2765"
					x2="63.8387"
					y2="36.2765"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
				<linearGradient
					id="paint2_linear_2869_17994"
					x1="-0.242145"
					y1="47.3142"
					x2="64.645"
					y2="47.3142"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
				<linearGradient
					id="paint3_linear_2869_17994"
					x1="-0.64523"
					y1="60.7169"
					x2="64.2419"
					y2="60.7169"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
				<linearGradient
					id="paint4_linear_2869_17994"
					x1="1.1367"
					y1="7.48008"
					x2="62.8631"
					y2="7.48008"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
				<linearGradient
					id="paint5_linear_2869_17994"
					x1="1.13691"
					y1="9.88768"
					x2="63.6547"
					y2="9.88768"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
				<linearGradient
					id="paint6_linear_2869_17994"
					x1="1.13676"
					y1="9.88768"
					x2="63.6545"
					y2="9.88768"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
				<linearGradient
					id="paint7_linear_2869_17994"
					x1="19.5001"
					y1="99.9995"
					x2="44.5001"
					y2="99.9995"
					gradientUnits="userSpaceOnUse"
				>
					<stop stopColor="#9747FF" />
					<stop offset="1" stopColor="#F372C2" />
				</linearGradient>
			</defs>
		</SvgIcon>
	);
}
